// 导入封装的方法
import {
  post
} from '../http'

const CallForProposals = {
  add (params) {
    return post('/linkage/clue/proposal/websiteSelfAdd', params)
  },
  linkageClueListByPhone (params) {
    return post('/linkage/clue/proposal/linkageClueListByPhone', params)
  },
  info (params) {
    return post('/linkage/clue/proposal/info/' + params)
  }
}
export default CallForProposals
